// Transparent scrollbar that stays out of the way until the user scrolls —
// shared by ChatBV list surfaces (chat history, monitored reports) so they
// don't show a persistent scrollbar.
export const transparentScrollbar = {
  scrollbarColor: 'transparent transparent',
  '&::-webkit-scrollbar': {
    width: '6px',
  },
};
